/* eslint-disable react/jsx-key */
import 'bootstrap/dist/css/bootstrap.css';
import makeInspectable from 'mobx-devtools-mst';
import {Provider} from 'mobx-react';
import {onSnapshot} from 'mobx-state-tree';
// import * as Sentry from '@sentry/browser';
// import { onPatch } from "mobx-state-tree";
import React from 'react';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import ReactDOM from 'react-dom';
import {ToastProvider} from 'react-toast-notifications';
import '@fortawesome/fontawesome-pro/css/all.min.css';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import {ContextProviderComposer, MapProvider} from './apiContexts';
import AppContainer from './containers/app-container';
import LanguageProvider from './containers/language-container';
import {getStorageSnapshot} from './helpers/auth';
import {getToken} from './helpers/request';
import './index.sass';
import {setSnapshop} from './services/authService';
import * as serviceWorker from './serviceWorker';
import stores from './stores';
import AudioPlayer from './infra/AudioPlayer.js';
import EventsProvider from './providers/events';
import ReportJobNoticeProvider from './providers/report-job-notice';
import {Provider as RadixTooltipProvider} from '@radix-ui/react-tooltip';
import moment from 'moment';
import 'moment/locale/pt-br';
import {PlatformIntl} from './infra/PlatformIntl';

// Sentry.init({3
//   environment: config.environment,
//   dsn: 'https://fc8f4a0b0a8840e9afdbde50204dcfde@sentry.azultecnologia.com/6',
// });

// Configure moment.js locale based on user's browser language for i18n support
moment.locale(PlatformIntl.DEFAULT_LOCALE === 'pt' ? 'pt-br' : 'en');

const TOOLTIP_OPEN_DELAY = 100;

const initialState = getToken() ? getStorageSnapshot() : {};

const store = stores.create(initialState);

onSnapshot(store, ({session, auth, server, events}) =>
  setSnapshop({
    session,
    auth,
    server,
    // so a fila e a preferencia de som: o painel precisa sobreviver ao refresh, mas
    // position/positionBuffer/current sao estado de tela e so engordariam o snapshot
    events: {list: events.list, enabledSound: events.enabledSound},
  }),
);

const toastConfig = {
  autoDismissTimeout: 5000,
  placement: 'bottom-left',
};

AudioPlayer.getInstance().addTrack(new AudioPlayer.Track('siren', process.env.PUBLIC_URL + '/sound/siren.mp3'));

ReactDOM.render(
    <Provider store={store}>
      <ContextProviderComposer
        contextProviders={[
          <LanguageProvider />,
          <ToastProvider {...toastConfig} />,
          <MapProvider />,
          <EventsProvider />,
          <ReportJobNoticeProvider />,
          <RadixTooltipProvider delayDuration={TOOLTIP_OPEN_DELAY} />,
        ]}>
        <AppContainer />
      </ContextProviderComposer>
    </Provider>,
    document.getElementById('root'),
);

// onPatch(store, patch => console.log(patch));
makeInspectable(store);

serviceWorker.unregister();
